import styled from 'styled-components'

const FulfilmentCollectionTitle = styled.p`
  &&& {
    padding-left: 8px;
    font-weight: ${props => props.theme.font.weight.bold};
    margin-bottom: 0;
  }
`
const FulfilmentCollectionHeader = styled.div`
  display: flex;
  align-items: center;
`
const FulfilmentActionRow = styled.div`
  margin-left: 33px;
  margin-top: 15px;

  a,
  button + span {
    margin-left: 15px;
  }
`
const FulfilmentMessagePanel = styled.div`
  padding-top: 10px;
  position: relative;
  z-index: 1;
  border-top: 1px solid ${props => props.theme.color.monochrome.light};
`
const FulfilmentCollectionContainer = styled.div`
  padding: 0;
  position: relative;
  margin: 10px 0;
  background-color: ${props => props.theme.color.monochrome.white};
`

export {
  FulfilmentCollectionTitle,
  FulfilmentCollectionHeader,
  FulfilmentActionRow,
  FulfilmentMessagePanel,
  FulfilmentCollectionContainer
}
